export const messages = {
  en: {
    purchase: {
      stepTitle: {
        selectItems: 'Select Items',
        applyInfo: 'Application Information',
        approvers: 'Approvers'
      },
      itemInfo: {
        title: 'Item Information',
        selectItems: 'Select Items',
        itemName: 'Item Name',
        itemCode: 'Item Code',
        price: 'Price',
        stock: 'Stock',
        applyQuantity: 'Apply Quantity',
        requiredQuantity: 'Required, please fill in the application quantity',
        remark: 'Remark'
      },
      applyInfo: {
        title: 'Application Information',
        userName: 'User Name',
        userPhone: 'Phone Number',
        applyDesc: 'Application Description',
        requiredField: 'Required field'
      },
      validation: {
        quantityRequired: 'Please enter application quantity',
        quantityPositive: 'Quantity must be greater than 0',
        phoneInvalid: 'Please enter valid phone number',
        descMaxLength: 'Description cannot exceed 200 characters'
      },
      buttons: {
        prevStep: 'Previous',
        nextStep: 'Next',
        submit: 'Submit',
        cancel: 'Cancel'
      }
    }
  },
  zh: {
    purchase: {
      stepTitle: {
        selectItems: '选择物品',
        applyInfo: '申请信息',
        approvers: '审批人'
      },
      itemInfo: {
        title: '物品信息',
        selectItems: '选择物品',
        itemName: '物品名称',
        itemCode: '物品编码',
        price: '物品价格',
        stock: '物品库存',
        applyQuantity: '申请数量',
        requiredQuantity: '必填，请填写申请数量',
        remark: '备注'
      },
      applyInfo: {
        title: '申请信息',
        userName: '使用人',
        userPhone: '联系电话',
        applyDesc: '申请说明',
        requiredField: '必填项'
      },
      validation: {
        quantityRequired: '请输入申请数量',
        quantityPositive: '数量必须大于0',
        phoneInvalid: '请输入有效的手机号码',
        descMaxLength: '说明不能超过200个字符'
      },
      buttons: {
        prevStep: '上一步',
        nextStep: '下一步',
        submit: '提交',
        cancel: '取消'
      }
    }
  }
}